import { useEffect, useState } from "react";
import { useDebounce } from "./DebounceHook";

export default function AddressInput({
  address,
  setAddress,
  suggestions,
  setSuggestions,
  setPlaceId,
  errors,
  call,
}) {
  const [isSelected, setIsSelected] = useState(!!address);
  const debouncedAddress = useDebounce(address, 400);

  // Google Places Autocomplete
  useEffect(() => {
    if (
      isSelected || // 🚫 prevent re-fetch after selection
      !window.google ||
      !debouncedAddress ||
      debouncedAddress.length < 3
    ) {
      return;
    }

    const service = new window.google.maps.places.AutocompleteService();

    service.getPlacePredictions(
      {
        input: debouncedAddress,
        // componentRestrictions: { country: "in" },
      },
      (predictions, status) => {
        if (
          status ===
          window.google.maps.places.PlacesServiceStatus.OK
        ) {
          setSuggestions(predictions);
        } else {
          setSuggestions([]);
        }
      }
    );
  }, [debouncedAddress, isSelected, setSuggestions]);

  return (
    <div style={{ position: "relative", width: "100%" }}>
      {/* Address Input */}
      <label
        className="form-label"
        style={{ fontSize: "12px", marginBottom: "0px", display: "block" }}
      >
        Address
      </label>
      <input
        className="form-control mt-0"
        placeholder="Please enter address"
        value={address}
        onChange={(e) => {
          setAddress(e.target.value);
          setPlaceId(null);
          setIsSelected(false); // 🔓 allow autocomplete again
        }}
        autoComplete="new-password"
      />

      {errors?.address && (
        <div className="text-danger" style={{ fontSize: "12px" }}>
          {errors.address}
        </div>
      )}

      {/* Suggestions Dropdown */}
      {suggestions.length > 0 && !isSelected && (
        <div
          className="dropdown-menu show"
          style={{
            width: "100%",
            maxHeight: 250,
            overflowY: "auto",
            zIndex: 9999,
          }}
        >
          {suggestions.map((item) => (
            <div
              key={item.place_id}
              className="dropdown-item"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setAddress(item.description);
                if (call) call(item.description,item.place_id); // ✅ safe call
                setPlaceId(item.place_id);
                setSuggestions([]);
                setIsSelected(true); // 🔒 stop autocomplete
              }}
            >
              {item.description}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
